import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'

const useSmsPhoneNumberCollectionFeature = (registryId: number) => {
  const { flagValue } = useFeatureFlag('24f_ff_registry_sms_frontend', false, {
    registryId,
  })

  return flagValue
}

export default useSmsPhoneNumberCollectionFeature
